import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { BlockService } from 'src/app/services/block.service';
import { InputformatService } from 'src/app/services/inputformate.service';

@Component({
  selector: 'app-classinfo',
  templateUrl: './classinfo.component.html',
  styleUrls: ['./classinfo.component.scss']
})
export class ClassinfoComponent implements OnInit {
formEditMode: boolean=true;
submitbtn:any
form:FormGroup
classList: any;
filterclassList: any;
  currentDate: any;

  constructor(
     @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
     public dialogRef: MatDialogRef<ClassinfoComponent>,
     private formBuilder: FormBuilder,
     private blockService:BlockService,
     private alertService:AlertService,
     private inputFormatService:InputformatService
  ) { 
    if (this.dataRecievedToAdd.item.id === 0) {
      this.submitbtn = 'Save';
    } else {
      this.submitbtn = 'Update';
    }
    if (this.dataRecievedToAdd.item.actionInfo == 1) {
      this.formEditMode = false
    }
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  }

  ngOnInit() {
    //console.log(this.dataRecievedToAdd);
    this.initialValidators();
    this.getClassList();
    if(this.dataRecievedToAdd.item.id>0)
    {
      this.getById()
    }
  }

  initialValidators()
  {
    this.form=this.formBuilder.group({
      id:[this.dataRecievedToAdd.item.id],
      schoolName:[this.dataRecievedToAdd.name.name],
      classType:['',Validators.required],
      noOfBoy:['',Validators.required],
      noOfGirl:['',Validators.required],
      schoolId:[this.dataRecievedToAdd.name.id],
      
    })
  }

  getById()
  {
    this.blockService.getClassInfoById(this.dataRecievedToAdd.item.id).subscribe(res=>{
      this.form.patchValue(res);
    })
  }
  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

  getClassList()
  {
    this.blockService.getclassType().subscribe(res=>{
      this.classList=res;
      this.filterclassList=this.classList.slice();
      if(this.classList.length==1)
      {
        this.form.controls['classType'].setValue(this.classList[0].key);
      }
    })
  }

  onSubmit()
  { 
    if(this.form.valid)
  {
    this.blockService.saveClassDetails(this.form.value).subscribe(res=>{
      if(res.isSuccess)
      {
        this.alertService.success(this.dataRecievedToAdd.item.id==0?"Class Information Details Added Sucessfully":"Class Information Details Updated Sucessfully");
        this.dialogRef.close(true);
      }
      else{
        this.alertService.error(res.htmlFormattedFailures);
      }
    })
  }
  else{
    this.form.markAllAsTouched();
  }
  }

  onCancel()
  {
    this.dialogRef.close();
  }

}
